import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { getCompanyResponses } from "../../utils/api/submissions";
import { Icon } from "@iconify-icon/react/dist/iconify.mjs";

function Response() {
  const dispatch = useDispatch();
  const [formResponses, setFormResponses] = useState([]);
  const [selectedResponse, setSelectedResponse] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();

  const [currentPage, setCurrentPage] = useState(1);
  const responsesPerPage = 20;

  const openModal = (responses) => {
    setSelectedResponse(responses);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedResponse(null);
  };

  const companyId = "6703ed2f59f269d7865b7eb7";

  useEffect(() => {
    getCompaniesData();
  }, [dispatch]);

  const getCompaniesData = async () => {
    try {
      const result = await getCompanyResponses(companyId);
      setFormResponses(result?.data?.responses || []);
    } catch (err) {
      console.log(err);
    }
  };

  const indexOfLastResponse = currentPage * responsesPerPage;
  const indexOfFirstResponse = indexOfLastResponse - responsesPerPage;
  const currentResponses = formResponses
    .slice()
    .reverse()
    .slice(indexOfFirstResponse, indexOfLastResponse);

  const totalPages = Math.ceil(formResponses.length / responsesPerPage);

  return (
    <div className="mr-5 p-4">
      <div className="flex items-center">
        <Icon
          onClick={() => navigate("/dashboard/companies")}
          className="text-4xl pr-2 cursor-pointer"
          icon="ion:arrow-back-circle-outline"
        />
        <h1 className="py-6 text-3xl font-semibold">All Responses</h1>
      </div>

      {!formResponses ? (
        <p>Loading...</p>
      ) : currentResponses.length > 0 ? (
        <>
          <div className="overflow-y-auto h-[70vh]">
            <table className="w-full text-center border rounded-lg shadow-lg">
              <thead className="bg-gray-200">
                <tr>
                  <th className="py-3 border-b">Employee Name</th>
                  <th className="py-3 border-b">Employee Email</th>
                  <th className="py-3 border-b">Form Name</th>
                  <th className="py-3 border-b">Action</th>
                </tr>
              </thead>
              <tbody>
                {currentResponses.map((responses, index) => (
                  <tr
                    key={index}
                    className="transition duration-200 hover:bg-gray-100"
                  >
                    <td className="py-2 border-b">
                      {responses.employeeId.name}
                    </td>
                    <td className="py-2 border-b">
                      {responses.employeeId.email}
                    </td>
                    <td className="py-2 border-b">
                      {responses.companyId.form.name}
                    </td>
                    <td className="py-2 border-b">
                      <button
                        className="px-4 py-2 font-semibold text-white transition duration-200 ease-in-out transform bg-blue-600 border rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-50 hover:scale-105"
                        onClick={() => openModal(responses)}
                      >
                        Show Response
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="flex justify-center items-center gap-2 flex-wrap mt-4">
            <button
              className="px-4 py-2 font-semibold text-white bg-blue-600 rounded hover:bg-blue-700"
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
            >
              Previous
            </button>
            <span>
              Page {currentPage} of {totalPages}
            </span>
            <button
              className="px-4 py-2 font-semibold text-white bg-blue-600 rounded hover:bg-blue-700"
              onClick={() =>
                setCurrentPage((prev) => Math.min(prev + 1, totalPages))
              }
              disabled={currentPage === totalPages}
            >
              Next
            </button>
          </div>
        </>
      ) : (
        <p>No Response found</p>
      )}

      {isModalOpen && selectedResponse && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="w-1/3 p-6 bg-white overflow-y-auto h-[80%] rounded-lg shadow-lg">
            <h2 className="mb-4 text-xl font-bold">
              Responses for {selectedResponse.employeeId.name}
            </h2>

            <div className="space-y-4">
              {selectedResponse.response.map((field, fieldIndex) => (
                <div key={fieldIndex} className="flex flex-col">
                  <label className="font-semibold">{field.fieldName}</label>
                  <input
                    className="px-2 py-1 border rounded-md"
                    type="text"
                    value={field.fieldValue}
                    readOnly
                  />
                </div>
              ))}
            </div>

            <div className="flex justify-end mt-4">
              <button
                className="px-4 py-2 text-white bg-red-500 rounded hover:bg-red-700"
                onClick={closeModal}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

function ResponseTable({ responses, openModal }) {
  return (
    <table className="w-full text-center border rounded-lg shadow-lg">
      <thead className="bg-gray-200">
        <tr>
          <th className="py-3 border-b">Employee Name</th>
          <th className="py-3 border-b">Employee Email</th>
          <th className="py-3 border-b">Form Name</th>
          <th className="py-3 border-b">Action</th>
        </tr>
      </thead>
      <tbody>
        {responses.map((responses, index) => (
          <tr key={index} className="transition duration-200 hover:bg-gray-100">
            <td className="py-2 border-b">{responses.employeeId.name}</td>
            <td className="py-2 border-b">{responses.employeeId.email}</td>
            <td className="py-2 border-b">{responses.companyId.form.name}</td>
            <td className="py-2 border-b">
              <button
                className="px-4 py-2 font-semibold text-white transition duration-200 ease-in-out transform bg-blue-600 border rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-50 hover:scale-105"
                onClick={() => openModal(responses)}
              >
                Show Response
              </button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

export default Response;
